import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import backendPlugin, { clearTranslationCache } from './backendPlugin';
import zhTW from './zh-TW.json';
import zhCN from './zh-CN.json';
import enUS from './en-US.json';

i18n
  .use(backendPlugin)
  .use(initReactI18next)
  .init({
    resources: {
      'zh-TW': { translation: zhTW },
      'zh-CN': { translation: zhCN },
      'en-US': { translation: enUS },
    },
    partialBundledLanguages: true,
    lng: localStorage.getItem('wems_crm_locale') || 'zh-TW',
    fallbackLng: 'zh-TW',
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', () => {
  clearTranslationCache();
});

export default i18n;
